/**
 * Created by dingkang.li on 2018/2/28.
 */
import Cookies from 'js-cookie'

class Cookie extends Cookies {

  static setDefaults(defaults) {
    Cookies.defaults = defaults;
  }

  static getAllCookie(){
    return this.get();
  }
  static clearAllCookie(){
      let cookies = this.get()
     for(let i in cookies) {
        this.remove(i)
      }
  }

  static setCookies(arr) {
      arr.forEach((v,i) => {
        this.set(v['key'],v['value'],{expires:v['expires'],path:v['path']})
      })
    }

}

Cookie.getCookie = Cookie.get;
Cookie.setCookie = Cookie.set;
Cookie.clearCookie = Cookie.remove;

export {
  Cookie as default
};


// WEBPACK FOOTER //
// ./src/utils/cookie.js